<template>
  <div class="gf_pricing__plan gf_pricing__container">
    <!-- Current Trial Plan -->
    <template>
      <div>
        <PlanPricingRow>
          <template #default="{content, key}">
            <RowHeaderItem :planNo="key" :old-plan="content.old_plan" :yearlyMode="yearlyMode" :title="content.title" :description="content.description" :featureDescription="content.feature_description" :extraData="content.extra_data" :expire-text="content.expire_text" :live-chat="content.live_chat" :features="content.features" :isRecommended="recommended === key" :isCurrentPlan="checkCurrentPlan(plan, key)" />
          </template>
        </PlanPricingRow>
        <PlanPricingRow>
          <template #default="{content, key}">
            <RowPricingItem :planNo="key" :old-plan="content.old_plan" :yearlyMode="yearlyMode" :title="content.title" :description="content.description" :featureDescription="content.feature_description" :extraData="content.extra_data" :expire-text="content.expire_text" :live-chat="content.live_chat" :features="content.features" :isRecommended="recommended === key" :isCurrentPlan="checkCurrentPlan(plan, key)" />
          </template>
        </PlanPricingRow>
        <PlanPricingRow>
          <template #default="{content, key}">
            <RowIntroItem :planNo="key" :old-plan="content.old_plan" :yearlyMode="yearlyMode" :title="content.title" :description="content.description" :featureDescription="content.feature_description" :extraData="content.extra_data" :expire-text="content.expire_text" :live-chat="content.live_chat" :features="content.features" :isRecommended="recommended === key" :isCurrentPlan="checkCurrentPlan(plan, key)" />
          </template>
        </PlanPricingRow>
        <PlanPricingRow>
          <template #default="{content, key}">
            <RowFooterItem :planNo="key" :old-plan="content.old_plan" :yearlyMode="yearlyMode" :title="content.title" :description="content.description" :featureDescription="content.feature_description" :extraData="content.extra_data" :expire-text="content.expire_text" :live-chat="content.live_chat" :features="content.features" :isRecommended="recommended === key" :isCurrentPlan="checkCurrentPlan(plan, key)" />
          </template>
        </PlanPricingRow>
      </div>
    </template>
  </div>
</template>

<script>
import promotion from "@/modules/Pricing/mixins/promotion";
import plan from "@/modules/Pricing/mixins/plan";
import PlanPricingRow from "@/modules/Pricing/components/PlanPricingItem/PlanPricingRow";
import RowHeaderItem from "@/modules/Pricing/components/PlanPricingItem/PlanPricingRow/RowHeaderItem";
import RowPricingItem from "@/modules/Pricing/components/PlanPricingItem/PlanPricingRow/RowPricingItem";
import RowIntroItem from "@/modules/Pricing/components/PlanPricingItem/PlanPricingRow/RowIntroItem";
import RowFooterItem from "@/modules/Pricing/components/PlanPricingItem/PlanPricingRow/RowFooterItem";
import { PLAN_NO } from "@/contants/plan";

export default {
  name: "PricingItem",
  components: {
    PlanPricingRow,
    RowHeaderItem,
    RowPricingItem,
    RowIntroItem,
    RowFooterItem
  },
  mixins: [promotion(), plan()],
  props: {
    yearlyMode: Boolean
  },
  methods: {
    checkCurrentPlan(plan, key) {
      if (key == PLAN_NO.DEVELOPMENT_STORE && this.isDevelopmentStore) {
        return true;
      }
      if (this.isDevelopmentStore) {
        return false;
      }
      return plan === key || key === this.currentPlanUpgrade
    }
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
